import { path } from 'ramda';

import { FEATURE_NAME } from '@/features/bonusTransactionLevelHistoryPage/consts';
import { PAGES_STORE_KEY } from '@/redux/constants';

export const getItemsRoot = path([PAGES_STORE_KEY, FEATURE_NAME, 'items']);

export const getQueryRoot = path([PAGES_STORE_KEY, FEATURE_NAME, 'query']);
